<template>
    <div class="open-container">
        <Nav :currentActive="'About'" />

        <div class="open-banner">
            <div class="banner">
                <img src="@/assets/images/about-banner.jpg" />
            </div>
            <div class="banner-desc">
                <div class="banner-desc-text">
                    <div class="title">关于我们</div>
                    <div class="text">支撑制造业数字化、网络化、智能化转型发展，是面向全球服务的国家级区块链新型基础设施。</div>
                </div>
                
            </div>
        </div>
        <div class="about-intro pt100 pb110">
            <div class="contain">
                <div class="com-tit fs34 text-center wow fadeInUp" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
                    公司简介
                </div>
                <div class="main flex flex-align-center flex-wrap-wrap flex-justify-between mt46 wow com-animate-f" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s;">
                    <div class="lft">
                        <div class="heading relative">
                            <div class="title fs24">
                                链网协同构建新业态
                            </div>
                            <div class="title fs24">
                                粤澳齐心共建新秩序
                            </div>
                        </div>
                        <div class="text mt30">
                            <p>
                                “星火·链网” 是在工业和信息化部指导及在国家相关专项政策的支持下，由中国信通院牵头，联合北京航空航天大学、北京邮电大学、中国联通集团等多家单位设计建设的区块链服务网络，是国家推动区块链新型基础设施建设的重要战略布局。
                            </p>
                            <p>
                                “星火·链网”使用区块链技术来建设分布式、多方参与、广泛共识的交互与信任体系，为工业互联网应用提供统一的对象标识机制、统一的身份认证机制和统一的价值交换机制，支撑制造业数字化、网络化、智能化转型发展，是面向全球服务的国家级区块链新型基础设施。
                            </p>
                        </div>
                        <div class="bg">
                            <img src="@/assets/images/about-intro-text-bg.png" class="full-width" ondragstart="return false"> 
                        </div>
                    </div>
                    <div class="rgt">
                        <img src="@/assets/images/company-img.jpg" alt="" class="text" ondragstart="return false"> 
                    </div>
                </div>
            </div>
        </div>

        <div class="about-company pt110 pb110">
            <div class="bg">
                <div class="bg-l">
                    <img src="@/assets/images/about-company-bg-left.jpg" class="full-maxWidth" ondragstart="return false"> 
                </div>
                <div class="bg-r">
                    <img src="@/assets/images/about-company-bg-right.jpg" class="full-maxWidth" ondragstart="return false"> 
                </div>
            </div>
            <div class="contain">
                <div class="com-tit fs34 text-center wow fadeInUp" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
                    战略合作公司
                </div>
                <ul class="list mt46 flex flex-justify-between flex-wrap-wrap wow com-animate-f" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s;">
                    <li class="item">
                        <div class="logo">
                            <img src="@/assets/images/logo1.png" alt="" ondragstart="return false"> 
                        </div>
                        <div class="title mt14 fs20">
                            广东云湾工业互联网有限公司
                        </div>
                        <div class="desc mt24">
                            <p>
                                浪潮云湾是浪潮集团大湾区工业互联网产业总部级企业，是工业互联网基础设施建设商和制造业智能化转型综合服务商。主要开展工业互联网产业应用推广服务以及相关技术研发工作。提供全云化、全场景的制造业智能化转型解决方案，重点开展标识解析、工业安全、确定性网络等核心技术研究。
                            </p>
                        </div>
                    </li>
                    <li class="item">
                        <div class="logo">
                            <img src="@/assets/images/logo2.png" alt="" width="160" height="53" title="" align="" ondragstart="return false"> 
                        </div>
                        <div class="title mt14 fs20">
                            珠海横琴融贯国际科技发展公司
                        </div>
                        <div class="desc mt24">
                            <p>
                                横琴融贯专注于发展产业数字化新基建、产业营运、产业投资、产业开发等全国性项目。公司目前聚焦于产业互联的数字经济。以“推动产业振兴，增进民生福祉”为责任。加大力度发展多边贸易, 同时将深耕药食同源健康食品发展, 微生态健康数据管理， 用创新、科学手法引领中医药健康管理产业发展。
                            </p>
                        </div>
                    </li>
                    <li class="item">
                        <div class="logo">
                            <img src="@/assets/images/logo3.png" alt="" ondragstart="return false"> 
                        </div>
                        <div class="title mt14 fs20">
                            北京泰尔英福科技有限公司
                        </div>
                        <div class="desc mt24">
                            <p>
                                泰尔英福（Teleinfo）是中国信息通信研究院（CAICT）于2012年设立的全资子公司。中国信通院定位“国家高端专业智库，产业创新发展平台”，是国家在信息通信和互联网等新兴科技领域重要的研究支撑机构。作为CAICT的工业互联网产业化平台，Teleinfo是国家高新技术企业和中关村高新技术企业。
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="about-contact pt110 pb110">
            <div class="contain">
                <div class="com-tit fs34 text-center wow fadeInUp" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">联系我们</div>
                <div class="main flex flex-justify-between mt44 flex-wrap wow com-animate-f" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s;">
                    <div id="map">
                        <MapComponent />
                    </div>
                    <div class="rgt">
                        <div class="title-en">
                            Zhuhai Hengqin integrates international technology
                        </div>
                        <div class="title fs24">
                            珠海横琴融贯国际科技发展有限公司
                        </div>
                        <ul class="flex flex-wrap-wrap">
                            <li>
                                <i><img src="@/assets/images/about-contact-icon1.png" ondragstart="return false"></i> 
                                <div class="info">
                                    <div class="tit">
                                        公司地址
                                    </div>
                                    <p>
                                        广东省珠海横琴粤澳深度合作区跨境电商(华发)创新产业园2栋 401-2
                                    </p>
                                </div>
                            </li>
                            <li>
                                <i><img src="@/assets/images/about-contact-icon2.png" ondragstart="return false"></i> 
                                <div class="info">
                                    <div class="tit">
                                        邮编
                                    </div>
                                    <p>
                                        518000
                                    </p>
                                </div>
                            </li>
                            <li>
                                <i><img src="@/assets/images/about-contact-icon3.png" ondragstart="return false"></i> 
                                <div class="info">
                                    <div class="tit">
                                        热线电话
                                    </div>
                                    <p>
                                        +853 28335475
                                    </p>
                                </div>
                            </li>
                            <li>
                                <i><img src="@/assets/images/about-contact-icon4.png" ondragstart="return false"></i> 
                                <div class="info">
                                    <div class="tit">
                                        电子邮箱
                                    </div>
                                    <p>
                                        contact@guiamacau.com
                                    </p>
                                </div>
                            </li>
                        <!--
                            <li>
                                <i><img src="@/assets/images/about-contact-icon5.png" /></i> 
                                <div class="info">
                                    <div class="tit">
                                        公司总机
                                    </div>
                                    <p>
                                        0755-292799999
                                    </p>
                                </div>
                            </li>
                        -->
                            <li>
                                <div class="info">
                                    <div class="tit">
                                        微信公众号
                                    </div>
                                    <p>
                                        <img src="@/assets/images/wx-qrcode.jpg" alt="" ondragstart="return false"> 
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
        <Footer />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import Nav from '../../components/NavTop.vue';
  import Footer from '../../components/Footer.vue';
  import MapComponent from './components/Map.vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .open-container {
    padding-top: 84px;
 }

 .open-banner {
    position: relative;
 }
 .open-banner .banner {
    width: 100%;
 }
 .open-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .open-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
    text-shadow: 2px 2px 1px #000000;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .open-banner .banner-desc .title {
    font-size: 30px;
 }
 .open-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }

    .about-intro {
        padding: 90px 0;
    }
    .contain {
        margin: 0 auto;
        width: 1200px;
    }
    .com-tit {
        color: #333333;
        font-weight: 500;
        line-height: 1.1;
        font-size: 28px;
        text-align: center;
    }

    .about-intro .lft {
        width: 45%;
        position: relative;
        z-index: 2;
    }
    .about-intro .lft .heading {
        background: url(@/assets/images/about-intro-heading-bg.png) no-repeat center left / contain;
        background-size: 100px;
        padding-top: 30px;
    }
    .about-intro .lft .title {
        line-height: 30px;
        font-weight: 500;
        color: #1c4892;
        font-size: 24px;
    }
    .about-intro .lft .title + .title {
        margin-top: 5px;
    }
    .about-intro .lft .text {
        font-size: 16px;
        line-height: 28px;
        color: #777777;
        margin-top: 24px;
    }
    .about-intro .lft .bg {
        position: absolute;
        width: 370px;
        height: 350px;
        right: -12%;
        top: 0;
        z-index: -1;
        animation: _opactiy 5s ease infinite;
    }

    .about-intro .rgt {
        width: 50%;
    }

    .about-company {
        background: #f6f7fb;
        position: relative;
        z-index: 2;
        overflow: hidden;
        padding: 90px 0;
    }
    .about-company .bg-l {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: -1;
        animation: toggleMoveDown 6s ease both infinite;
    }
    .about-company .bg-r {
        position: absolute;
        right: 0;
        top: 0;
        z-index: -1;
        animation: toggleMoveTop 6s ease both infinite;
    }
    .about-company .list {
        position: relative;
        z-index: 2;
        margin-top: 34px;
    }
 
    .about-company .list .item {
        background: #fff;
        border-radius: 5px;
        width: calc(32.5% - 60px);
        min-height: 402px;
        padding: 30px;
        transition: box-shadow .4s ease;
    }
    .about-company .list .item:hover {
        box-shadow: 0px 12px 18px 0px rgba(124, 160, 203, 0.23);
    }
    .about-company .list .item .logo {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .about-company .list .item .logo img {
        max-height: 100%;
        width: auto;
        object-fit: cover;
    }
    .about-company .list .item .title {
        font-weight: 500;
        color: #333333;
        text-align: center;
    }
    .about-company .list .item .desc {
        font-size: 15px;
        line-height: 24px;
        color: #888888;
    }

    .about-contact {
        padding: 90px 0;
    }

    #map {
        height: 464px;
        width: 50%;
        border-radius: 5px;
        border: 2px solid #eeeeee;
    }
    .about-contact .rgt {
        flex: 1;
        padding-left: 50px;
    }

    .about-contact .rgt .title-en {
        font-family: Arial;
        color: #777777;
        font-weight: bold;
        text-transform: uppercase;
        line-height: 1;
    }
    .about-contact .rgt .title {
        color: #333333;
        font-weight: 500;
        padding-bottom: 16px;
        margin-top: 5px;
        border-bottom: 2px solid #ececec;
    }
    .about-contact .rgt li {
        display: flex;
        align-items: center;
        width: calc(50% - 30px);
        padding: 40px 0;
        position: relative;
    }
    .about-contact .rgt li:first-child {
        width: 100%;
    }
    .about-contact .rgt li:not(:first-child) {
        border-top: 1px solid #efefef;
    }
    .about-contact .rgt li:not(:first-child):nth-child(odd) {
        padding-left: 60px;
    }
    .about-contact .rgt li i {
        width: 40px;
        height: 40px;
        background: #ea5413;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .about-contact .rgt li .info {
        flex: 1;
        padding-left: 18px;
    }
    .about-contact .rgt li .info .tit {
        color: #333333;
        font-size: 16px;
        line-height: 1;
        font-weight: 500;
    }
    .about-contact .rgt li .info p {
        font-size: 14px;
        color: #777777;
        margin-top: 6px;
    }
  </style>